export const preguntasFrecuentes = [
    {
        id: 1,
        link: 'costo-plataforma',
        pregunta: '¿El uso de esta plataforma es gratuito?',
        respuesta: "Sí, puedes utilizar la plataforma sin costo, siempre que cumplas con las condiciones de uso y no realices actividades ilegales."
    },
    {
        id: 2,
        link: 'que-ofrece-la-plataforma',
        pregunta: '¿Qué ofrece Coneecta para los usuarios?',
        respuesta: "Coneecta es una plataforma integral que sirve para conectar a los buscadores de empleo con oportunidades de trabajo que se adapten de acuerdo a su perfil y ayudar a las empresas a encontrar candidatos calificados para sus posibles vacantes."
    },
    {
        id: 3,
        link: 'funciones-de-coneecta',
        pregunta: '¿Cuáles son las funciones disponibles en la plataforma?',
        respuesta: "La plataforma ofrece varias funciones tanto para los buscadores de empleo como para las empresas, permitiéndoles buscar vacantes y candidatos, aplicar a vacantes, crear perfiles y publicar vacantes entre otras funciones. Al aprovechar al máximo estas funciones, puedes mejorar tus posibilidades de encontrar el empleo o un candidato ideal para algún puesto."
    },
    {
        id: 4,
        link: 'codigo-verificacion',
        pregunta: '¿Qué puedo hacer si no he recibido el código de confirmación para completar mi registro en la plataforma?',
        respuesta:
            <ul>
                <li>Verifica la dirección de correo electrónico</li>
                <li>Revisa la carpeta de spam o correo no deseado</li>
                <li>Espera un poco más</li>
                <li>Reenvía el código de confirmación</li>
            </ul>
    },
    {
        id: 5,
        link: 'habilidades-experiencias-necesarias',
        pregunta: '¿Cuáles son las habilidades y experiencia necesarias para obtener un trabajo en un campo específico?',
        respuesta: "Debes tener habilidades y experiencia relevantes para ese campo. Estas habilidades y experiencia pueden variar según la industria y el trabajo específico que estés buscando."
    },
    {
        id: 6,
        link: 'informacion-oportunidades-laborales',
        pregunta: '¿Dónde puedo encontrar información sobre las oportunidades de empleo?',
        respuesta: <iframe src="https://scribehow.com/shared/Donde_puedo_encontrar_informacion_sobre_las_oportunidades_de_empleo__QSow9WunSru1jPDHQu2Lrg" width="100%" height="640" allowfullscreen frameborder="0"></iframe>
    },
    {
        id: 8,
        link: 'eliminar-cuenta',
        pregunta: '¿Cómo puedo eliminar mi cuenta?',
        respuesta: <iframe src="https://scribehow.com/shared/Como_puedo_eliminar_mi_cuenta__rwbhMrBsSAWhqzTV9pZpBQ" width="100%" height="640" allowfullscreen frameborder="0"></iframe>
    },
    /*{
        id: 9,
        link: 'olvide-mi-contraseña',
        pregunta: '¿Olvidaste tu contraseña?',
        respuesta: <iframe src="https://scribehow.com/embed/How_to_Reset_Your_Password_on_Coneectanet__M2HxkQizQfaCppgmXrK9ng?as=scrollable" width="100%" height="640" allowfullscreen frameborder="0"></iframe>
    },*/
    {
        id: 10,
        link: 'horarios-de-atencion',
        pregunta: '¿Cuál es el horario de atención de Coneecta?',
        respuesta: "El horario de atención es de 9:00 a.m. a 6:00 p.m. de lunes a viernes excluyendo días festivos nacionales declarados por la Procuraduría Federal de la Defensa del Trabajo. El medio utilizado para contacto en caso de soporte es a través de correo electrónico a soporte@coneecta.net"
    }
]


export const preguntasBDE = [
    {
        id: 1,
        link: 'crear-cuenta',
        pregunta: '¿Cómo crear cuenta?',
        respuesta: <iframe src="https://scribehow.com/shared/Crear_una_cuenta_en_Coneecta_Guanajuato_como_Buscador_de_empleo__e1tXJDqjRaWo7uQgKTn8nw" width="100%" height="640" allowfullscreen frameborder="0"></iframe>
    },
    /*{
        id: 2,
        link: 'iniciar-sesion',
        pregunta: '¿Cómo iniciar sesión?',
        respuesta: <iframe src="https://scribehow.com/embed/How_to_Login_and_Logout_from_Coneecta__Gx9pmgW1TIeZX8RdjzjDyw?as=scrollable" width="100%" height="640" allowfullscreen frameborder="0"></iframe>
    },*/
    {
        id: 3,
        link: 'opciones-encontrar-empleo',
        pregunta: '¿Con que opciones cuenta la plataforma para encontrar un tipo de empleo de acuerdo mis necesidades?',
        respuesta:
            <p>
                Existen varias opciones las cuales son:
                <ul>
                    <li>Por tarea completada/destajo</li>
                    <li>Fines de semana</li>
                    <li>Medio tiempo (4 hrs)</li>
                    <li>Nocturno</li>
                    <li>Temporal</li>
                    <li>Tiempo completo (8 hrs)</li>
                    <li>Turnos (rotativos)</li>
                </ul>
            </p>
    },
    {
        id: 4,
        link: 'consultar-curp',
        pregunta: 'Consultar mi CURP',
        respuesta:
            <p>
                Para hacerlo, necesitarás proporcionar algunos datos personales:
                <ul>
                    <li>Nombre Completo</li>
                    <li>Fecha de nacimiento</li>
                    <a href="https://www.gob.mx/curp/" target="_blank"> Consultar tu CURP aquí </a>
                </ul>
            </p>
    },
    {
        id: 5,
        link: 'consulatar-codigo-postal',
        pregunta: 'Consultar mi Código Postal',
        respuesta:
            <p>
                Puedes consultar tu Código Postal en línea a través del sitio web oficial del Servicio Postal Mexicano, para hacerlo necesitarás algunos datos como:
                <ul>
                    <li>Estado</li>
                    <li>Municipio</li>
                    <li>Asentamiento</li>
                    <a href="https://www.correosdemexico.gob.mx/SSLServicios/ConsultaCP/Descarga.aspx" target="_blank"> Consultar aquí </a>
                </ul>
            </p>
    },
    /*{
        id: 6,
        link: 'actualizar-perfil',
        pregunta: '¿Cómo puedo actualizar mi perfil?',
        respuesta: <iframe src="https://scribehow.com/embed/Actualizacion_del_perfil_como_Buscador_de_enpleo__QHEH9juiTzKZeMEjMvynaQ?as=scrollable" width="100%" height="640" allowfullscreen frameborder="0"></iframe>
    }*/
    /*{
        id: 7,
        link: '',
        pregunta: '¿Dónde puedo buscar información actualizada sobre las vacantes disponibles en las empresas?',
        respuesta: ""
    },
    {
        id: 8,
        link: '',
        pregunta: '¿Cuáles son las mejores formas de buscar y encontrar ofertas de trabajo en mi área?',
        respuesta: ""
    }
    */
]

export const preguntasEmpresa = [
    {
        id: 1,
        link: 'crear-cuenta-empresa',
        pregunta: '¿Cómo puedo crear una cuenta para mi empresa?',
        respuesta: <iframe src="https://scribehow.com/shared/Como_puedo_crear_una_cuenta_para_mi_empresa__AdLO5iS3RMKsvS_rQh3SIQ" width="100%" height="640" allowfullscreen frameborder="0"></iframe>
    },
    /*{
        id: 2,
        link: 'iniciar-sesion-empresa',
        pregunta: '¿Cómo puedo iniciar sesión?',
        respuesta: <iframe src="https://scribehow.com/embed/Iniciar_sesion_como_Empresa__HBPiWOO2TqGg5zDooQIY9w?as=scrollable" width="100%" height="640" allowfullscreen frameborder="0"></iframe>
    },*/
    {
        id: 3,
        link: 'publicar-oferta-laboral',
        pregunta: '¿Cómo puedo publicar una oferta de trabajo?',
        respuesta: <iframe src="https://scribehow.com/shared/Como_puedo_publicar_una_oferta_de_trabajo__F6ts2sObTXaHcmGR8J8cYA" width="100%" height="640" allowfullscreen frameborder="0"></iframe>
    },
    {
        id: 4,
        link: 'encontrar-candidatos',
        pregunta: '¿Cómo puedo contactar a los posibles candidatos para una vacante?',
        respuesta: <iframe src="hhttps://scribehow.com/shared/Como_puedo_contactar_a_los_posibles_candidatos_para_una_vacante__B3uvKi1HSnS5ORCDd3oIjQ" width="100%" height="640" allowfullscreen frameborder="0"></iframe>
    },
    /*{
        id: 5,
        link: 'buscar-candidatos',
        pregunta: '¿Cómo puedo buscar candidatos adecuados para una oferta de trabajo específica?',
        respuesta: <iframe src="https://scribehow.com/embed/Buscar_vacante__wRo6HBY6QFG1N5H_r0rH2Q?as=scrollable" width="100%" height="640" allowfullscreen frameborder="0"></iframe>
    },
        id: 6,
        link: 'actualizar-perfil-empresa',
        pregunta: '¿Cómo puedo actualizar mi perfil?',
        respuesta: <iframe src="https://scribehow.com/embed/Actualizacion_del_perfil_como_Empresa__4yuAasVqR6m2ZZaH7xiFPw?as=scrollable" width="100%" height="640" allowfullscreen frameborder="0"></iframe>
    },*/
    {
        id: 7,
        link: 'informacion-requerida-registro-empresa',
        pregunta: '¿Qué datos específicos de mi empresa necesito para el proceso de registro?',
        respuesta:
            <ul>
                <li>Nombre comercial</li>
                <li>Número de teléfono</li>
                <li>Correo de la empresa</li>
                <li>Razón social registrada ante el SAT</li>
                <li>Registro Federal de Contribuyentes (RFC)</li>
                <li>Tamaño de la empresa</li>
                <li>Tipo de empresa</li>
                <li>Sector</li>
                <li>Actividad</li>
                <li>Principales perfiles dentro de la empresa</li>
                <li>Tipo sucursal</li>
                <li>Dirección de la empresa</li>
            </ul>
    },
    {
        id:8,
        link:'agendar-entrevista',
        pregunta: '¿Cuál es el proceso para agendar una entrevista?',
        respuesta: <iframe src="https://scribehow.com/shared/Cual_es_el_proceso_para_agendar_una_entrevista__w6_sduFKTT-RUJdpzww_oQ" width="100%" height="640" allowfullscreen frameborder="0"></iframe>
    }
]